import React from 'react';
import './LogoHeaderComponent.css';
import Logo  from '../../Assets/Svg/Falla_Plaza_Rodrigo.svg';
import { Link } from 'react-router-dom';

export const LogoHeader = (props) => {
  return (
    <div className='LocoContent'>
      <Link to='/' className='LogoHeaderComponent'>
      <img src={Logo} alt='Logo' className='LogoComponent' />
      <h1>{props.I18n.PlazaRodrigoFalla}</h1>
    </Link>
    </div>
    

  );
}
